// extracted by mini-css-extract-plugin
export default {"wrapper":"AppContent_wrapper__WCeJZ"};